import type { VariantProps } from 'class-variance-authority';
import type { PrimitiveProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as ContentBlock } from './Block.vue';

export interface ContentBlockProps extends PrimitiveProps {
	titleAs?: PrimitiveProps['as'];
	class?: HTMLAttributes['class'];
	titleClass?: HTMLAttributes['class'];
	contentClass?: HTMLAttributes['class'];
	variant?: BlockVariants['variant'];
	title?: string;
}

export const blockVariant = cva('bg-white-dark-2 px-5 py-8', {
	variants: {
		variant: {
			'white-dark-1': 'bg-white-dark-1',
			'white-dark-2': 'bg-white-dark-2',
			'white-dark-3': 'bg-white-dark-3'
		}
	},
	defaultVariants: {
		variant: 'white-dark-2'
	}
});

export type BlockVariants = VariantProps<typeof blockVariant>;

export const contentVariant = cva('size-full px-4 pb-6 pt-4 md:p-11', {
	variants: {
		variant: {
			'white-dark-1': 'bg-white',
			'white-dark-2': 'bg-white',
			'white-dark-3': 'bg-white'
		}
	},
	defaultVariants: {
		variant: 'white-dark-2'
	}
});

export type ContentVariants = VariantProps<typeof contentVariant>;

export const titleVariant = cva(
	'pb-4 text-left font-matter-sq text-2xl font-normal leading-normal tracking-[-0.48px] text-primary',
	{
		variants: {
			variant: {
				'white-dark-1': 'text-primary',
				'white-dark-2': 'text-primary',
				'white-dark-3': 'text-primary'
			}
		},
		defaultVariants: {
			variant: 'white-dark-2'
		}
	}
);

export type TitleVariants = VariantProps<typeof titleVariant>;
